var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglassSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2604 10.8906L7.3359 8.00385C7.11688 7.67531 7 7.2893 7 6.89445V3.75C8.25 3.625 10 3.5 12 3.5C14 3.5 15.75 3.625 17 3.75V6.89445C17 7.2893 16.8831 7.67531 16.6641 8.00385L14.7396 10.8906C14.2917 11.5624 14.2917 12.4376 14.7396 13.1094L16.6641 15.9962C16.8831 16.3247 17 16.7107 17 17.1056V20.25C15.75 20.375 14 20.5 12 20.5C10 20.5 8.25 20.375 7 20.25V17.1056C7 16.7107 7.11688 16.3247 7.3359 15.9962L9.2604 13.1094C9.70827 12.4376 9.70827 11.5624 9.2604 10.8906Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.25V17.1056C7 16.7107 7.11688 16.3247 7.3359 15.9962L9.2604 13.1094C9.70827 12.4376 9.70827 11.5624 9.2604 10.8906L7.3359 8.00385C7.11688 7.67531 7 7.2893 7 6.89445V3.75M7 20.25C5.75 20.125 5 20 5 20M7 20.25C8.25 20.375 10 20.5 12 20.5C14 20.5 15.75 20.375 17 20.25M7 3.75C5.75 3.875 5 4 5 4M7 3.75C8.25 3.625 10 3.5 12 3.5C14 3.5 15.75 3.625 17 3.75M17 20.25V17.1056C17 16.7107 16.8831 16.3247 16.6641 15.9962L14.7396 13.1094C14.2917 12.4376 14.2917 11.5624 14.7396 10.8906L16.6641 8.00385C16.8831 7.67531 17 7.2893 17 6.89445V3.75M17 20.25C18.25 20.125 19 20 19 20M17 3.75C18.25 3.875 19 4 19 4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassSolid);
export default __webpack_public_path__ + "static/media/hourglass-solid.61cb235dea046dd030cd5abb1b82b8fc.svg";
export { ForwardRef as ReactComponent };